import styled from "@emotion/styled";
import { Icon } from "office-ui-fabric-react";
import React from "react";

type Props = {
  count: number;
  className?: string;
  label?: string;
};

export const SearchResultsCount = ({ count, className, label }: Props) => {
  return (
    <Root className={className}>
      <IconContainer>
        <StyledIcon iconName="CircleFill" />
      </IconContainer>
      <ResultsLabel>{label}</ResultsLabel>
      <ResultNumber>{count}</ResultNumber>
    </Root>
  );
};

const Root = styled.div`
  display: flex;
  flex-direction: row;
`;

const IconContainer = styled.div`
  margin-top: -3px;
`;

const ResultsLabel = styled.div`
  font-size: 14px;
  color: ${p => p.theme.palette.neutralPrimary};
  margin-right: 5px;
  @media (max-width: 800px) {
    display: none;
  }
`;

const ResultNumber = styled.div`
  font-size: 14px;
  color: ${p => p.theme.palette.neutralPrimary};
  width: 20px;
`;

const StyledIcon = styled(Icon)`
  font-size: 8px;
  color: ${p => p.theme.palette.themePrimary};
  margin-right: 8px;
`;
